export interface IVotingSession {
  id: string;
  tournamentId: string;
  tournamentCategoryId?: string;
  isOpen: boolean;
  eligibleVoterType: number; // 0 = AllUsers, 1 = ParticipantsOnly
  allowSelfVote: boolean;
  allowSameTeamVote: boolean;
  selectedAwards?: string[]; // Array of award IDs included in voting
  createdBy: string;
  createdAt: string;
  tournamentName?: string;
  tournamentCategoryName?: string;
  createdByUserName?: string;
}

export interface IAwardVote {
  id: string;
  votingSessionId: string;
  awardId: string;
  voterId: string;
  votedPlayerId: string;
  createdAt: string;
  awardName?: string;
  voterName?: string;
  votedPlayerName?: string;
}

export interface IVotingResult {
  awardId: string;
  awardName: string;
  votedPlayerId: string;
  votedPlayerName: string;
  voteCount: number;
}

export interface IVotingResultsSummary {
  votingSessionId: string;
  votingSessionName: string;
  results: IVotingResult[];
}

export interface ICreateVotingSessionRequest {
  tournamentId: string;
  tournamentCategoryId?: string;
  eligibleVoterType: number;
  allowSelfVote?: boolean;
  allowSameTeamVote?: boolean;
  selectedAwards?: string[]; // Array of award IDs to include in voting
}

export interface IUpdateVotingSessionRequest {
  isOpen?: boolean;
  eligibleVoterType?: number;
  allowSelfVote?: boolean;
  allowSameTeamVote?: boolean;
  selectedAwards?: string[]; // Array of award IDs to include in voting
}

export interface ICastVoteRequest {
  votingSessionId: string;
  awardId: string;
  votedPlayerId: string;
}

export interface IVotingSessionResponse {
  data: IVotingSession[];
  success: boolean;
  message: string;
  errors: string[];
}

export interface IVotingSessionSingleResponse {
  data: IVotingSession;
  success: boolean;
  message?: string;
}

export interface IVotesResponse {
  data: IAwardVote[];
  success: boolean;
  message?: string;
}

export interface IVotingResultsResponse {
  data: IVotingResultsSummary;
  success: boolean;
  message?: string;
}

export interface ICanVoteResponse {
  data: boolean;
  success: boolean;
  message?: string;
}

export enum EligibleVoterType {
  AllUsers = 0,
  ParticipantsOnly = 1,
}
